import Swiper from "swiper/bundle";
import { Scrollbar } from "swiper/modules";

const colSwiper = document.getElementsByClassName("text-swiper");
if (colSwiper.length > 0) {
  new Swiper(".text-swiper", {
    modules: [Scrollbar],
    speed: 700,
    direction: "horizontal",
    slidesPerGroup: 1,
    grabCursor: true,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 50,
      },
      1600: {
        slidesPerView: 1.25,
        spaceBetween: 100,
      },
    },
  });
}
